import { action } from "typesafe-actions";

import { message } from "antd";

import { AuthActionTypes } from "./types";

export const tokenFetchRequest = (username: string, password: string, reCaptchaToken: string) =>
  action(AuthActionTypes.FETCH_REQUEST, { username, password, reCaptchaToken });

export const tokenFetchSuccess = (payload: { token: string }) => action(AuthActionTypes.FETCH_SUCCESS, payload);

export const tokenFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AuthActionTypes.FETCH_ERROR);
};

export const fetchLogout = () => action(AuthActionTypes.LOGOUT);

export const tokenFetchLocalStorage = () => action(AuthActionTypes.FETCH_LOCAL_STORAGE);
